import $ from "jquery";

export class PasswordToggle {
  constructor($el) {
    this.$el = $el;
    this.button = this.$el.find("button");
    this.input = this.$el.find("input");

    this.bindEvents();
  }

  bindEvents() {
    let thisToggle = this;

    thisToggle.button.on("click", function() {
      let currentState = thisToggle.input.attr("type");

      if (currentState == "password") {
        thisToggle.input.attr("type", "text");
      }
      else {
        thisToggle.input.attr("type", "password");
      }
    });
  }
}
